import {GuiButton} from "@nolimitcity/slot-launcher/bin/gui/buttons/GuiButton";

export class RockBottomPickButton extends GuiButton {
    constructor(name: string, callback?: Function) {
        super(name, callback);

        const tempSprite = new PIXI.Sprite(PIXI.Texture.WHITE);
        tempSprite.width = 72;
        tempSprite.height = 125;
        tempSprite.anchor.set(0.5);
        tempSprite.alpha = 0;
        this.hitArea = new PIXI.Rectangle((tempSprite.x - (tempSprite.width / 2)), (tempSprite.y - (tempSprite.height / 2)), tempSprite.width, tempSprite.height);

        this.addChild(tempSprite);
    }
}